import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { ChevronRight, Star, Award, Shield, CheckCircle2, Maximize2, Timer, Sparkles } from 'lucide-react';
import balkon from "../assets/balkon.webp"
import balkon2 from "../assets/8.webp"
import { IoIosCheckmark } from "react-icons/io";
import logo from "../assets/logodark.png"
import balkonlar from "../assets/dusakabinler.webp"
import { Helmet } from 'react-helmet';

import { MdOutlineWorkspacePremium } from "react-icons/md";
import Footer from '../components/Footer';
import gorsel1 from "../assets/2.webp";
import gorsel2 from "../assets/7.webp";
import gorsel3 from "../assets/dus2.webp";
import gorsel4 from "../assets/dusakabin.webp";
import gorsel5 from "../assets/dus4.webp";
import { useNavigate } from 'react-router-dom';

import { Menu } from 'lucide-react'

const Dusakabin = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
 const toggleMenu = () => {
   setIsMenuOpen(!isMenuOpen);
 };



  const images = [
    gorsel1,
    gorsel3,
    balkon2,
    gorsel2,
    gorsel4,
    gorsel5
  ];

  const features = [
    {
      icon: <Timer className="w-6 h-6" />,
      title: "Hızlı Montaj",
      description: "Profesyonel ekip ile 24 saat içinde montaj"
    },
    {
      icon: <Maximize2 className="w-6 h-6" />,
      title: "Özel Ölçü",
      description: "Mekanınıza özel ölçülendirme"
    },
    {
      icon: <Sparkles className="w-6 h-6" />,
      title: "Premium Malzeme",
      description: "A+ kalite malzeme kullanımı"
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Estetik Tasarım",
      description: "Modern dokunuşlarla alanınıza değer katan ürünler"
    }
  ];

  const specs = [
    "Suya dayanıklı profiller", "Kolay temizlenebilir yüzey", "Uzun ömürlü yapı", "Şık ve modern tasarım", "Kaymaz taban"
  ];


  return (
    <Container>
            <Helmet>
        <title>Duşakabin Sistemleri- Şık ve Kullanışlı Çözümler</title>
        <meta name="description" content="Duşakabin Sistemleri ile Evinize Şıklık Katın." />
        <meta name="keywords" content="söke duşakabin, kuşadası duşakabin ,didim duşakabin,duşakabin fiyatları" />
      </Helmet>
        <NavigationBar>
          <div onClick={()=> navigate("/")}>
            <Logo src={logo} alt="logo" />
          </div>
          <MenuButton onClick={toggleMenu}>
            <Menu size={24} />
          </MenuButton>
          <MenuItems isOpen={isMenuOpen}>
          <a href="#hizmetler">   <StyledTitle>HİZMETLERİMİZ</StyledTitle></a>
            <StyledTitle>HAKKIMIZDA</StyledTitle>
            <a href="##">  <StyledTitle>İLETİŞİM</StyledTitle></a>
          </MenuItems>
        </NavigationBar>



        <SectionDiv>
      <TextSection>
        <Badge>
          <MdOutlineWorkspacePremium style={{ width: "20px", height: "20px" }} />
          Premium Seri
        </Badge>

        <Title2>Ev Sistemlerinde En iyisi</Title2>
        <Step>
          <StepNumber style={{ paddingRight: "3px", paddingLeft: "5px" }}>01</StepNumber>
          <StepTitle>Kaliteli ve Dayanıklı Malzeme</StepTitle>
          <StepDescription>
          Yüksek kaliteli cam ve suya dayanıklı profiller kullanıyoruz. Yıllara meydan okuyacak sağlamlıkta duşakabin çözümleri sunuyoruz.
          </StepDescription>
        </Step>
        <Step>
          <StepNumber>02</StepNumber>
          <StepTitle>Estetik ve Modern Tasarım</StepTitle>
          <StepDescription>
          Banyonuzun tarzına uygun minimalist ve şık duşakabin tasarımları ile yaşam alanlarınıza modern bir dokunuş katıyoruz.
          </StepDescription>
        </Step>
        <Step>
          <StepNumber>03</StepNumber>
          <StepTitle>Kolay Temizlik ve Bakım
          </StepTitle>
          <StepDescription>
          Kir tutmayan yüzeylerle duşakabinlerimiz, temizliği kolay ve hijyenik bir kullanım sağlar.          </StepDescription>
        </Step>
      </TextSection>
      <ImageContainerr>
        <img src={balkonlar} style={{ width: "100%" }} />
      </ImageContainerr>
    </SectionDiv>


      {/* Features Grid */}
      <FeaturesSection>
        <SectionTitle>Neden Bizi Tercih Etmelisiniz?</SectionTitle>
        <FeaturesGrid>
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: idx * 0.1 }}
              viewport={{ once: true }}
            >
              <FeatureCard>
                <FeatureIcon>{feature.icon}</FeatureIcon>
                <FeatureTitle>{feature.title}</FeatureTitle>
                <FeatureDescription>{feature.description}</FeatureDescription>
              </FeatureCard>
            </motion.div>
          ))}
        </FeaturesGrid>
      </FeaturesSection>

      <DetailsContainer>
        <DetailsContent>
          <Badge>
            <MdOutlineWorkspacePremium style={{ width: "20px", height: "20px" }} />
            Premium Seri
          </Badge>
          <Title>Premium Duşakabin Sistemi</Title>
          <Description>
            Şıklığı ve fonksiyonelliği birleştiren duşakabinlerimiz, banyonuzda güvenliği ve estetiği ön planda tutar. Yüksek kaliteli cam ve menteşe sistemleriyle uzun süreli dayanıklılık sağlar. Pratik temizliğiyle bakım kolaylığı sunar.

          </Description>
          <SpecList>
            {specs.map((spec, idx) => (
              <SpecItem key={idx}>
                <IoIosCheckmark style={{ color: "#D40D12", width: "25px", height: "25px" }} />
                <span style={{ fontFamily: "Poppins", color: "#4e4e4e" }}>{spec}</span>
              </SpecItem>
            ))}
          </SpecList>
        </DetailsContent>
        <ImageContainer>
          <Img src={balkon2} />
        </ImageContainer>
      </DetailsContainer>


      <div style={{ width:"90%",margin:"auto" }}>

      <SectionTitle>Fotoğraf Galerisi </SectionTitle>
        <GalleryWrapper>
          {images.map((image, index) => (
            <ImageItem key={index}>
              <img src={image} alt={`image-${index}`} />
            </ImageItem>
          ))}
        </GalleryWrapper>
      </div>
      <Footer />
    </Container>
  );
};

export default Dusakabin;


const Img = styled.img`
height: 100%;
border-top-right-radius: 40px;
border-bottom-right-radius:40px;
 object-fit: cover;
 @media (max-width: 768px) {
  border-top-right-radius: 0px;
border-bottom-right-radius:0px;
 width: 100%;
  }
`;

const GalleryWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;  /* Aralık */
  justify-content: center;  /* Ortalamayı sağlar */
  align-items: center;  /* Dikeyde de ortalar */
  margin-top: 40px;
`;


const Logo = styled.img`
  width: 200px;
  cursor:pointer;
  
  @media (max-width: 768px) {
    width: 130px;
  }
`;
const ImageItem = styled.div`
  flex: 0 0 calc(50% - 16px);  /* İki sütun için düzen */
  justify-content: center;
  box-sizing: border-box;
  img {
    width: 80%;
    height: 500px;
    border-radius: 8px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;  /* Ekran küçüldüğünde tek sütun */
  }
`;


const SectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  justify-content: center;
  background-color: #f9f9f9;
  margin: 0px 70px;
  border-radius: 40px;
  height: auto;

  @media (min-width: 768px) {
    flex-direction: row;
    height: 110vh;
  }
  
  @media (max-width: 768px) {
    margin-right:  25px;
    margin-left:  10px;

  }
`;

const TextSection = styled.div`
  margin-right: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media (min-width: 768px) {
    margin-right: 20px;
    width: 50%;
  }
`;

const Title2 = styled.h1`
  font-size: 2rem;
  font-family: Poppins;
  font-weight: 600;
  margin-bottom: 30px;

  @media (min-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 50px;
  }
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Step = styled.div`
  margin-bottom: 20px;
`;

const StepNumber = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: #2e2e2e;
  display: inline;
  font-family: Poppins;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const StepTitle = styled.h2`
  font-size: 1.1rem;
  display: inline;
  font-weight: 600;
  font-family: Poppins;
  color: #202020;
  padding-left: 10px;
  margin-bottom: 5px;

  @media (min-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
`;

const StepDescription = styled.p`
  font-size: 14px;
  font-family: Poppins;
  padding-left: 35px;
  color: #666;

  @media (min-width: 768px) {
    font-size: 15px;
    padding-left: 50px;
  }
`;
const SeeMoreButton = styled.button`
  padding: 10px 20px;
  font-size: 0.9rem;
  color: #fff;
  background-color: #000;
  border: none;
  cursor: pointer;
  margin-top: 20px;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;



const ImageContainerr = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  @media (min-width: 768px) {
    width: 40%;
    margin-top: 0;
  }
`;



const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 768px) {
  }
`;

const NavigationBar = styled.div`
  width: 100vw;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 0 20px;
  }
`;

const MenuItems = styled.div`
  display: flex;
  gap: 80px;
  margin: 25px;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100px;
    right: 0;
    background: white;
    width: 200px;
    gap: 20px;
    padding: 20px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    z-index: 1000;
    margin: 0;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 20px;
  color: #282828;
  @media (max-width: 768px) {
    display: block;
  }
`;

const StyledTitle = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  color: #28231e;
  font-weight: 500;
  letter-spacing: 1px;

  @media (min-width: 768px) {
    font-size: 17px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin : 0px 60px;
  margin-bottom: 80px;
  
  border-radius: 40px;
  overflow: hidden;

  @media (min-width: 768px) {
    flex-direction: row;
    height: 90vh;
  }
  @media (max-width: 768px) {
    margin : 0px 10px;
    margin-bottom: 50px;

  }
`;

const DetailsContent = styled.div`
  padding: 3rem;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 5rem;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
  }
 
`;

const ImageContainer = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 50%;
  }
`;

const HeroContent = styled.div`
  position: relative;
  height: 80vh;
  margin: 50px auto;
  width: 100%;
  padding: 0 2rem;
  display: flex;
  background-image: url(${balkon});
  background-size: cover;
  border-radius: 40px;
  background-position: bottom;
  justify-content: center;
  align-items: center;
  color: #fff;

  @media (min-width: 768px) {
    height: 90vh;
    width: 90%;
    padding: 0 3rem;
    margin: 70px auto;
  }
`;

const Badge = styled.div`
  background-color: #D40D12;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  width: max-content;
  color: white;
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  color: #322f2f;
  font-weight: 700;
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-family: Poppins;
  color: #474242;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const SpecList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const SpecItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 10px;
`;

const FeaturesSection = styled.section`
  padding: 3rem 2rem;
  margin: 50px;

  @media (min-width: 768px) {
    padding: 4rem 2rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  font-family: Poppins;
  text-align: center;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FeatureCard = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  height: 160px;

  @media (min-width: 768px) {
    height: 180px;
  }
`;

const FeatureIcon = styled.div`
  margin-bottom: 1rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

const FeatureDescription = styled.p`
  color: #777;
  font-size: 0.9rem;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;